/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.programs.combos.create.description.controllers', [
  'acme.common.service.api'
])

.controller('ProgramsCombosCreateDescriptionController', ['$scope', '$state', '$timeout', 'ApiService', 'CalendarService', 'ValidateService', function($scope, $state, $timeout, ApiService, CalendarService, ValidateService) {
    var watchers = {};

    $scope.programsCombosCreateDescription = {

      isSubmitted: false,

      model: {
        name: '',
        shortDescription: '',
        description: '',
        emailConfirmation: ''
      },
      next : '',
      combo: null,
      shortDescriptionMax: 300,
      shortDescriptionRemaining: 300,

      shortSummernoteConfig: {
        height: 100,
        focus: true,
        shortcuts: false,
        toolbar: [
          ['style', ['bold', 'italic', 'underline', 'clear']],
          ['fontsize', ['fontsize']],
          ['color', ['color']],
          ['para', ['ul', 'ol', 'paragraph']],
          ['height', ['height']]
        ]
      },

      longSummernoteConfig: {
        height: 200,
        focus: false,
        toolbar: [
          ['style', ['bold', 'italic', 'underline', 'clear']],
          ['fontsize', ['fontsize']],
          ['color', ['color']],
          ['para', ['ul', 'ol', 'paragraph']],
          ['height', ['height']]
        ]
      },

      emailSummernoteConfig: {
        height: 200,
        focus: false,
        shortcuts: false,
        toolbar: [
          ['style', ['bold', 'italic', 'underline', 'clear']],
          ['fontsize', ['fontsize']],
          ['color', ['color']],
          ['para', ['ul', 'ol', 'paragraph']],
          ['height', ['height']]
        ]
      },

      validators: [],

      init: function() {
        var title,
            titleLabel = 'Create Combo Description';

        $scope.$on("ProgramsCombosCreateController::save", this.onSave);
        $scope.$on('$destroy', this.onDestroy);

        this.initValidators();

        watchers.shortDescription = $scope.$watch('programsCreate.model.shortDescription', this.onShortDescriptionUpdate);

        if ($state.params && $state.params.comboId) {
          this.getCombo($state.params.comboId);
          titleLabel = 'Edit Combo Description';
        }

        title = {
          title: titleLabel,
          buttonLeft: {
            label: 'Cancel',
            action: function() {
              $state.go('application.programs.combos.list');
            }
          },
          buttonRight: {
            label: 'Save & Close',
            action: function() {
              $scope.programsCombosCreateDescription.complete(true);
            }
          }
        };

        $scope.$emit('Application::contentTitleChange', title);
      },

      onSave: function(e, data) {
        var self = $scope.programsCombosCreateDescription;
        self.next = data.state;
        self.complete();
      },

      complete : function(close) {
        var errorHandler = (close) ? this.error.saveAndClose : this.error.complete,
            successHandler = (close) ? this.success.saveAndClose : this.success.complete;

        $scope.$emit('ProgramsCombosCreateController::reset');
        this.isSubmitted = true;

        if (this.isValid()) {
          if (this.combo && this.combo.id) {
            ApiService.combo.templates.update(this.marshal.toJSON()).then(successHandler, errorHandler);
          } else {
            ApiService.combo.templates.create(this.marshal.toJSON()).then(successHandler, errorHandler);
          }
        }else{
          $scope.$emit('ProgramsCombosCreateController::error', {
            message:  'Please correct the errors below.'
          });
        }
      },

      checkShortDescription: function() {
        if (this.model.shortDescription) {
          console.log('ProgramsCreateController::checkShortDescription', this.model.shortDescription.length);
          this.model.shortDescription = this.model.shortDescription.replace(/[\s\n]+/g,' ');
          if (this.model.shortDescription > this.shortDescriptionMax) {
            this.model.shortDescription = this.model.shortDescription.substr(0, this.shortDescriptionMax);
          }
        }else{
          this.model.shortDescription = '';
        }
        this.shortDescriptionRemaining = this.shortDescriptionMax - this.model.shortDescription.length;
      },

      initValidators: function() {
        this.validators = [{
          field: 'programs-combos-create-description-name',
          len: {
            message: 'Please enter a valid name',
            test: function() {
              return {
                value: $scope.programsCombosCreateDescription.model.name
              };
            }
          }
        },
        {
          field: 'programs-combos-create-description-notify',
          equal: {
            message: 'Please enter valid email addresses',
            test: function() {
              var i,
                ii = 0,
                validCount = 0,
                self = $scope.programsCombosCreateDescription;

              if (self.model.emailNotify) {
                for (i = 0, ii = self.model.emailNotify.length; i < ii; i++) {
                  if (ValidateService.validators.email(self.model.emailNotify[i].email)) {
                    validCount++;
                  }
                }
              }

              // return ii === validCount;
              return [
                ii,
                validCount
              ];
            }
          }
        }];
      },

      isValid: function(field) {
        var r = true;

        if (this.isSubmitted) {
          if (typeof field === 'undefined') {
            r = ValidateService.validate(this.validators);
          } else {
            r = ValidateService.check(this.validators, field);
          }
        }
        return r;
      },

      getCombo : function(id) {
        ApiService.combo.templates.get(id).then(this.success.getCombo, this.error.getCombo);
      },

      success: {
        init: function(response) {},

        getCombo: function(response) {
          var self = $scope.programsCombosCreateDescription;
          self.marshal.fromJSON(response.data.payload);
        },

        complete: function(response) {
          var self = $scope.programsCombosCreateDescription;
          console.log('programsCombosCreateDescription::complete', response.data.payload);
          $state.go(self.next, { comboId: response.data.payload.id });
        },
        saveAndClose: function(response) {
          $scope.$emit('ProgramsCombosCreateController::success', {
            message: 'Successfully Saved!'
          });

          $scope.$emit('ProgramsCombosCreateController::transition', {
            state: 'application.programs.combos.list'
          });
        }
      },

      error: {
        init: function(response) {},

        getCombo: function(response) {

        },

        complete: function (response) {
          $scope.$emit('ProgramsCombosCreateController::error', {
            message:  response.data.error
          });
        },
        saveAndClose: function(response) {
          $scope.$emit('ProgramsCombosCreateController::error', {
            message:  response.data.error
          });
        }
      },

      marshal : {
        fromJSON : function(json) {
          var self = $scope.programsCombosCreateDescription;
          self.model.name = json.name;
          self.model.description = json.description;
          self.model.shortDescription  = json.shortDescription;
          self.model.emailConfirmation  = json.emailConfirmationMessage;
          self.model.emailNotify = json.emailNotify;
          self.combo = json;
        },

        toJSON : function() {
          var self = $scope.programsCombosCreateDescription;
          if (self.combo) {
            self.combo.startTime = CalendarService.toISO8601(self.combo.startTime);
            self.combo.endTime = CalendarService.toISO8601(self.combo.endTime);
            self.combo.name = self.model.name;
            self.combo.description = self.model.description;
            self.combo.shortDescription = self.model.shortDescription;
            self.combo.emailConfirmationMessage = self.model.emailConfirmation;
            self.combo.emailNotify = self.model.emailNotify;
          } else {
            self.combo = {
              startTime: CalendarService.toISO8601(new Date()),
              endTime: CalendarService.toISO8601(new Date()),
              name : self.model.name,
              description : self.model.description,
              shortDescription : self.model.shortDescription,
              emailConfirmationMessage : self.model.emailConfirmation,
              emailNotify : self.model.emailNotify
            };
          }

          return self.combo;
        }
      },

      onShortDescriptionUpdate: function(e, data) {
        $scope.programsCombosCreateDescription.checkShortDescription();
      },

      onDestroy: function(e, data) {
        // Remove watchers
        var watcher;

        for (watcher in watchers) {
          if (watchers.hasOwnProperty(watcher)) {
            watchers[watcher]();
          }
        }
      },

      getError: function(field) {
        return ValidateService.getError(field);
      },

      isValidEmailNotify: function(recipient) {
        return ValidateService.validators.email(recipient.email);
      },

      removeEmailNotifyRecipient: function(index) {
        if (this.model.emailNotify instanceof Array && this.model.emailNotify[index]) {
          this.model.emailNotify.splice(index, 1);
        }
      },

      addEmailNotifyRecipient: function() {
        if (!(this.model.emailNotify instanceof Array)) {
          this.model.emailNotify = [];
        }
        this.model.emailNotify.push({
          name: '',
          email: ''
        });
      },

    };

    $scope.programsCombosCreateDescription.init();

}]);